__turbopack_context__.v({
  "alert": "Footer-module__Grjkva__alert",
  "alertClose": "Footer-module__Grjkva__alertClose",
  "categoriesGrid": "Footer-module__Grjkva__categoriesGrid",
  "categoriesSection": "Footer-module__Grjkva__categoriesSection",
  "copyright": "Footer-module__Grjkva__copyright",
  "error": "Footer-module__Grjkva__error",
  "footerBottom": "Footer-module__Grjkva__footerBottom",
  "footerBottomLink": "Footer-module__Grjkva__footerBottomLink",
  "footerContainer": "Footer-module__Grjkva__footerContainer",
  "footerDescription": "Footer-module__Grjkva__footerDescription",
  "footerDivider": "Footer-module__Grjkva__footerDivider",
  "footerLink": "Footer-module__Grjkva__footerLink",
  "footerLinks": "Footer-module__Grjkva__footerLinks",
  "footerLogo": "Footer-module__Grjkva__footerLogo",
  "footerSection": "Footer-module__Grjkva__footerSection",
  "footerTitle": "Footer-module__Grjkva__footerTitle",
  "footerTop": "Footer-module__Grjkva__footerTop",
  "footerWrapper": "Footer-module__Grjkva__footerWrapper",
  "legalSection": "Footer-module__Grjkva__legalSection",
  "newsletterForm": "Footer-module__Grjkva__newsletterForm",
  "newsletterInput": "Footer-module__Grjkva__newsletterInput",
  "snackbar": "Footer-module__Grjkva__snackbar",
  "socialLink": "Footer-module__Grjkva__socialLink",
  "socialLinks": "Footer-module__Grjkva__socialLinks",
  "subscribeButton": "Footer-module__Grjkva__subscribeButton",
  "success": "Footer-module__Grjkva__success",
  "visible": "Footer-module__Grjkva__visible",
  "warning": "Footer-module__Grjkva__warning",
});
